import { memo } from 'react'
import * as Styled from './styled'
import RefillButton from 'components/RefillButton'
import { REF_LINKS } from 'consts/refLinks'

const AiImageGenerationCredits = () => {
  return (
    <Styled.CreditsInfoWrapper>
      <RefillButton referer={REF_LINKS.V_EDITOR_AI_IMAGE_REFILL} />
    </Styled.CreditsInfoWrapper>
  )
}

export default memo(AiImageGenerationCredits)
